/// <reference path="../_references.ts"/>

module App.Utils {
	export abstract class MenuItemController {
		public menuOptions: App.MenuItem[];
		constructor(protected $state: ng.ui.IStateService) {}

		doMenuAction(item: MenuItem): ng.IPromise<any> {
			return item.action();
		}

		abstract menuActionComplete(item: MenuItem): void;

		clickAction(item: MenuItem): void {
			if (angular.isDefined(item.action)) {
				item.loading = true;
				this.doMenuAction(item).then(() => {
					if (angular.isDefined(item.uiSref)) {
						this.$state.go(item.uiSref);
						this.menuActionComplete(item);
					}
				}).finally(() => {
					item.loading = false;
				});
			} else if (angular.isDefined(item.uiSref)) {
				this.$state.go(item.uiSref);
				this.menuActionComplete(item);
			}
		}
	}
}